import { AuditMetadata } from "./audit-metadata.model";
import { BaseStorableEntity } from "./base-storable-entity.model";

export class BaseAuditableEntity extends BaseStorableEntity {
  auditMetadata?: AuditMetadata;
  internalNotes?: string;
}
